export const getCardTagline = type => {
	let cardTagline='';
	if(type === 'attraction') {
		cardTagline='Cultural Highlights'
	} else if(type === 'culturalTour') {
		cardTagline='Cultural Tours & Music Holidays'
	} else if(type === 'opera') {
		cardTagline='Independent Opera Holiday'
	} else if(type === 'railJourney') {
		cardTagline='Rail Journey'
	} else if(type === 'review') {
		cardTagline='Staff Review'
	} else if(type === 'riverCruise') {
		cardTagline='River Cruise'
	} else if(type === 'hotelBreak') {
		cardTagline='Short Break'
	} else if(type === 'specialOffer') {
		cardTagline = 'Special Offer'
	} else if(type === 'tailorMadeHoliday') {
		cardTagline = 'Tailor-made Holiday'
	} else if(type === 'cityPage') {
		cardTagline = 'City'
	} else if(type === 'regionPage') {
		cardTagline = 'Region'
	} else return '';
	return cardTagline
}